const snakecase = str => str.replace(/([A-Z])/g, '_$1').toLowerCase()
  
export const snakecaseKeys = obj => {
  if (Array.isArray(obj)) {
    return obj.map(snakecaseKeys)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [snakecase(key), snakecaseKeys(value)])
    )
  }
  return obj
}
  